module.exports = __webpack_public_path__ + "img/pt02_samurai02_shop.ebbe68a3.png";